import React from 'react';
import { Container } from 'reactstrap';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { LOCATIONS } from 'constants/index';

import AppMeta from 'components/App/Meta';
import AppBreadcrumb from 'components/App/Breadcrumb';

// import SectionPictureList from 'pages/Location/LocationDetail/ManagerPicture/SectionPictureList';
import SectionPlacePictureList from 'pages/Location/LocationDetail/ManagerPicture/SectionPlacePictureList';
import SectionRoomPictureList from 'pages/Location/LocationDetail/ManagerPicture/SectionRoomPictureList';

import INITIAL_VALUE from 'constants/initialValue';

import styles from './ManagerPicture.module.scss';

function ManagerPicture(props) {
  const location = useLocation();
  const placeId = new URLSearchParams(location.search).get('place');

  const breadcrumbList = [
    {
      name: 'Chỗ nghỉ',
      isActive: false,
      link: `${LOCATIONS.LOCATION_DETAIL.DEFAULT}?place=${placeId}`,
    },
    {
      name: 'Hình ảnh chỗ nghỉ',
      isActive: true,
    },
  ];

  const {
    roomImageList,
    actionGetRoomImages,
    onResetRoomImageList,
  } = props;

  React.useEffect(() => {
    actionGetRoomImages({ placeId });

    return () => {
      onResetRoomImageList();
    };
  }, [actionGetRoomImages, onResetRoomImageList, placeId]);

  return (
    <div className={`page-content ${styles.Page}`}>
      <AppMeta name="Hình ảnh chỗ nghỉ" />

      <Container fluid>
        <AppBreadcrumb
          pageTitle="Hình ảnh chỗ nghỉ"
          breadcrumbList={breadcrumbList}
        />

        {/* <SectionPictureList /> */}

        <SectionPlacePictureList />

        {roomImageList.map((room) => (
          <SectionRoomPictureList
            key={room._id}
            roomId={room._id}
            title={room.name}
            roomType={room.roomName}
            roomPictureList={room.images}
            roomVideo={room.video}
            roomPreviewImage={room.previewImage}
          />
        ))}

      </Container>
    </div>
  );
}

ManagerPicture.propTypes = {
  roomImageList: PropTypes.instanceOf(Array),
  actionGetRoomImages: PropTypes.func,
  onResetRoomImageList: PropTypes.func,
};

ManagerPicture.defaultProps = {
  roomImageList: INITIAL_VALUE.ARRAY,
  actionGetRoomImages: INITIAL_VALUE.FUNCTION,
  onResetRoomImageList: INITIAL_VALUE.FUNCTION,
};

export default ManagerPicture;
